import sortBy from 'lodash/sortBy';
import omit from 'lodash/omit';
import IPreparedOrder from '../../context/interfaces/IPreparedOrder';
import { isDeliverMethod } from './index';
import { formatAddress } from '../../components/GooglePlacesComponent';
import { Order } from '../../context/OrderContext';
import { DeliveryMethod, CampaignQuery } from '../../generated/graphql';

const orderToAPI = (
  order: Order,
  campaign: Pick<NonNullable<CampaignQuery['campaignBySlug']>, 'deliveryOptions' | 'formFields'>,
  isDonationOnly?: boolean,
): IPreparedOrder => {
  const deliveryMethods = sortBy(campaign?.deliveryOptions?.deliveryMethods || []);
  const {
    deliveryMethod = deliveryMethods?.[0] || DeliveryMethod.Collect,
    quantities, customFields,
  } = order || {};

  const preparedQuantities = Object.keys(quantities).map((articleId) => ({
    articleId,
    quantity: quantities[articleId],
  }));

  const preparedCustomFields = Object
    .keys(customFields)
    .filter((fieldId) => (campaign.formFields || []).some(({ _id }) => _id === fieldId))
    .map((fieldId) => ({
      formField: fieldId,
      value: customFields[fieldId],
    }));

  return {
    ...omit(order, 'expiry'),
    ...(isDonationOnly ? {
      deliveryMethod: undefined,
      address: undefined,
      collectTimeslot: undefined,
    } : {
      deliveryMethod: deliveryMethod || deliveryMethods[0] || DeliveryMethod.Collect,
      address: isDeliverMethod(deliveryMethod) && order.address ? formatAddress(order.address) : undefined,
    }),
    quantities: preparedQuantities,
    customFields: preparedCustomFields,
  };
};

export default orderToAPI;
